import { Components, Theme } from '@mui/material';

export const getMuiAlert = (theme: Theme): Components['MuiAlert'] => {
  const neutralBackgroundColor = theme.palette.grey[300];
  const neutralBorderColor = theme.palette.grey[400];

  return {
    styleOverrides: {
      root: {
        borderRadius: 12,
        variants: [
          {
            props: { severity: 'watchduty-neutral', variant: 'filled' },
            style: {
              backgroundColor: neutralBackgroundColor,
            },
          },
          {
            props: { severity: 'watchduty-neutral', variant: 'standard' },
            style: {
              backgroundColor: neutralBackgroundColor,
            },
          },
          {
            props: { severity: 'watchduty-neutral', variant: 'outlined' },
            style: {
              border: `1px solid ${neutralBorderColor}}`,
            },
          },
        ],
      },
    },
  };
};
